import { gql } from '@apollo/client';

/** The first image of each product, for thumbnails. */
export default gql`
  query ProductImagesByIdsQuery($ids: [Int!]) {
    allProducts(filter: { id: { in: $ids } }) {
      nodes {
        id
        productImages: productImagesByProductId(first: 1) {
          nodes {
            url
          }
        }
      }
    }
  }
`;
